import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SEO from "@/lib/seo";
import { scrollToId } from "@/lib/ui";
import Hero from "@/sections/Hero";
import Editorial from "@/sections/Editorial";
import FeaturesBento from "@/sections/FeaturesBento";
import WhoNeeds from "@/sections/WhoNeeds";
import HowItWorksSection from "@/sections/HowItWorksSection";
import Compatibility from "@/sections/Compatibility";
import ComparisonTable from "@/sections/ComparisonTable";
import Capabilities from "@/sections/Capabilities";
import FAQSection from "@/sections/FAQSection";
import BlogPreview from "@/sections/BlogPreview";
import FinalCTA from "@/sections/FinalCTA";

export default function Home() {
  const { state, key } = useLocation();
  useEffect(() => {
    if (state?.scrollTool) scrollToId("#tool");
  }, [key, state?.scrollTool]);

  return (
    <>
      <SEO />
      <Hero />
      <Editorial />
      <FeaturesBento />
      <WhoNeeds />
      <HowItWorksSection />
      <Compatibility />
      <ComparisonTable />
      <Capabilities />
      <FAQSection />
      <BlogPreview />
      <FinalCTA />
    </>
  );
}
